import { useSection } from '@nucleus/web-theme';
import React from 'react';
import { useEnabledCodeSnippets } from '../hooks/useEnabledCodeSnippets';
import { GlobalStyle } from './GlobalStyle';

export const SectionGlobalStyle = (): JSX.Element | null => {
  const section = useSection();

  const codeSnippets = section?.payload?.codeSnippets ?? [];
  const cssSnippets = codeSnippets.filter((snippet) => snippet.language === 'css');
  const enabledCssSnippets = useEnabledCodeSnippets(cssSnippets);

  if (section === undefined || section.id === undefined) {
    return null;
  }

  const colorStyleMap = {
    '--color-section-background': section.payload?.backgroundMedia?.color?.hex,
    '--color-block-background': section.payload?.blockBackgroundMedia?.color?.hex,
  };

  return (
    <>
      {enabledCssSnippets.map((snippet) => (
        <GlobalStyle
          key={snippet.id}
          content={snippet.content}
          selector={`#${section.id}#${section.id}#${section.id}`}
        />
      ))}

      {Object.entries(colorStyleMap).map(([key, value]) => {
        if (value === undefined) {
          return null;
        }

        return (
          <GlobalStyle
            key={key}
            content={`${key}: ${value};`}
            selector={`#${section.id}#${section.id}#${section.id}`} // might not need 3x, but just in case
          />
        );
      })}
    </>
  );
};
